(() => {
  // utils/common.js
  function poll(condition, callback, persistent = false, timeout = 1e4, pollInterval = 25) {
    if (condition()) {
      callback(condition());
    } else if (timeout > 0) {
      setTimeout(() => {
        poll(condition, callback, persistent, persistent ? timeout : timeout - pollInterval, pollInterval);
      }, pollInterval);
    }
  }

  function q(s, o) {
    return o ? s.querySelector(o) : document.querySelector(s);
  }

  function insert(target, position, element, exists) {
    try {
      if (!exists) {
        typeof element === "string"
          ? target.insertAdjacentHTML(position, element)
          : target.insertAdjacentElement(position, element);
      }
    } catch (e) {
      console.debug(position, " :: ", element);
    }
  }

  var ID = "LIV-404";
  var VAR = "1";

  function testInfo(testName) {
    window.runningExperiments = window.runningExperiments || {};
    window.runningExperiments[ID] = {
      name: testName || "",
      variation: `${VAR}`,
      logs: []
    };

    poll(
      () => q("body"),
      () => {
        q("body").classList.add(`${ID}`, `${ID}_${VAR}`);
      }
    );
  }

  var metrics = [
    { title: "Geschmack:", value: 336 / 480, labels: ["Nicht meins", "Lecker", "Super lecker"] },
    { title: "Qualität:", value: 336 / 480, labels: ["Weniger gut", "Gut", "Sehr gut"] },
    { title: "Wirkung:", value: 288 / 480, labels: ["Keine", "Positiv", "Spürbar positiv"] },
    { title: "Sättigungsgefühl:", value: 336 / 480, labels: ["Noch Appetit", "Sättigend", "Gut sättigend"] }
  ];

  function initRating() {
    poll(
      () => window.ratingSnippet,
      () => {
        ratingSnippet("ruk_rating_snippet2", {
          store: "livefresh-de",
          lang: "de",
          color: "#FAD200",
          linebreak: false,
          usePolaris: true,
          text: "Bewertungen"
        });
      }
    );
  }

  function insertFeedbackSection() {
    poll(
      () => q(".tagesablauf__background"),
      () => {
        const anchor = q(".tagesablauf__background");
        const productDataSKU = window.meta?.product?.variants?.find((variant) => variant).sku;

        const markUp = `
          <div class="${ID}__feedback-section">
            <div class="${ID}__feedback-container">
              <div style="display: flex; align-items: center;" class="ruk_rating_snippet2 ${ID}__feedback-rating-snippet" data-sku="${productDataSKU}"></div>
              <div class="${ID}__feedback-rating">
                <div class="${ID}__feedback-rating-value"></div>
                <div class="${ID}__feedback-rating-details">
                  <div class="${ID}__feedback-rating-stars"></div>
                  <div class="${ID}__feedback-rating-count"></div>
                </div>
              </div>
              <button class="${ID}__feedback-button" device="desktop">Weitere Reviews lesen</button>
            </div>

            <div class="${ID}__feedback-text">Feedback aus der LiveFresh Community</div>

            <div class="${ID}__feedback-metrics">
              ${metrics
                .map(
                  (metric) => `
                <div class="${ID}__feedback-metric">
                  <div class="${ID}__feedback-metric-title">${metric.title}</div>
                  <div class="${ID}__feedback-metric-bar">
                    <div class="${ID}__feedback-metric-bar-fill" style="width: ${metric.value * 100}%"></div>
                  </div>
                  <div class="${ID}__feedback-metric-labels">
                    ${metric.labels
                      .map((label) => `<span class="${ID}__feedback-metric-label">${label}</span>`)
                      .join("")}
                  </div>
                </div>
              `
                )
                .join("")}
            </div>

            <button class="${ID}__feedback-button" device="mobile">Weitere Reviews lesen</button>
          </div>
        `;

        insert(anchor, "beforebegin", markUp, q(`.${ID}__feedback-section`));
        initRating();
      }
    );
  }

  function insertReviewData() {
    poll(
      () => q(`.${ID}__feedback-rating-snippet[aria-label]`),
      () => {
        const node = q(`.${ID}__feedback-rating-snippet[aria-label]`);
        const ratingData = node.getAttribute("aria-label").split(" Stars - ");
        const ratingValue = ratingData.shift();
        const ratingCount = ratingData.pop();
        const number = parseInt(ratingCount.match(/\d+/)[0]);
        const ratingCountFormatted = number.toLocaleString("en-US");
        const ratingCountFormattedWithUnit = ratingCount.replace(/\d+/, ratingCountFormatted);

        q(`.${ID}__feedback-rating-value`).textContent = ratingValue;
        q(`.${ID}__feedback-rating-count`).textContent = ratingCountFormattedWithUnit + " Bewertungen";
        insert(q(`.${ID}__feedback-rating-stars`), "beforeend", node);
        node.querySelector("span")?.remove();
      }
    );
  }

  function handleButtonClick() {
    poll(
      () => q(`.${ID}__feedback-section`),
      () => {
        q(`.${ID}__feedback-section`).addEventListener("click", (e) => {
          if (e.target.closest(`.${ID}__feedback-button`)) {
            q('[id*="#ReviewsWidget"]')?.scrollIntoView({ behavior: "smooth", block: "start" });
          }
        });
      }
    );
  }

  function mainJS() {
    testInfo("Add Communitiy Feedback on Saftkur PDP");
    insertFeedbackSection();
    insertReviewData();
    handleButtonClick();
  }

  // NUR MOBILE (wie im Original)
  if (window.matchMedia("(max-width: 767px)").matches) {
    mainJS();
  }
})();